/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './library-creative-link-creative-modal.component.html';
import {Uuid} from '../../components/util/uuid';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';

export interface LibraryCreativeLinkCreativeModalResult {
  destination: boolean;
  creativeId: string;
}

@Component({
  standalone: false,
  selector: 'adn-library-creative-link-creative-modal',
  template
})
export class LibraryCreativeLinkCreativeModalComponent implements OnInit {
  model: any;
  modelComms: any;
  onComplete: (result: LibraryCreativeLinkCreativeModalResult) => void;

  name = '';
  destination = true;
  disabled = false;
  validationErrors: any[] = [];

  private libraryCreative: any;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(CreativeResource) private readonly Creative: any,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.libraryCreative = this.model;
    this.name = this.defaultCreativeName(this.libraryCreative?.name);

    if (this.modelComms) {
      this.modelComms.addSubscriber((data: any, type: any) => {
        if (!type) {
          this.libraryCreative = data;
          this.name = this.defaultCreativeName(data?.name);
        }
      });
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  createSubmitted(): void {
    this.disabled = true;
    this.validationErrors = [];
    this.adnModalLoading.applyModalLoading();

    const creative = this.Creative.create({
      id: Uuid.generate(),
      name: this.name,
      libraryCreative: this.libraryCreative
    });

    creative.savePartial(['id', 'name', 'libraryCreative']).then((saved: any) => {
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.({destination: this.destination, creativeId: saved.id});
      this.bsModalRef.hide();
    }, (errors: any) => {
      this.disabled = false;
      this.validationErrors = _.get(errors, ['data', 'errors'], []);
      this.adnModalLoading.removeModalLoading();
    });
  }

  private defaultCreativeName(creativeName: string): string {
    return 'Creative linked to ' + (creativeName || 'this library creative');
  }
}
